import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["stroke"]
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    ref: "svg",
    class: "busy-logo",
    style: _normalizeStyle({ width: _ctx.size + 'px', height: _ctx.size + 'px' }),
    viewBox: "7 11 43 43",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, [
    _createElementVNode("g", {
      ref: "lines",
      fill: "none",
      stroke: _ctx.color,
      "stroke-width": "1.7",
      "stroke-linecap": "round"
    }, null, 8, _hoisted_1),
    _createElementVNode("g", {
      ref: "dots",
      fill: _ctx.color
    }, null, 8, _hoisted_2)
  ], 4))
}